//
// Footer.js
//
// author: marcio.garcia@newsoftware.com.br
//

import React from 'react'
import { Link } from 'react-router-dom'
import { msg } from '../defs/lang'

class Footer extends React.Component {

    render() {

        return (
            <footer id="footer">
                <div className="wrap">
                    <div className="footer__info">
                        <p className="">{msg.txtCopyright}</p>
                        <Link to="/content/PrivacyPolicy" >
                            <span className="nse-foot-txt">{msg.txtPrivacyPolicy}</span>
                        </Link>
                        <span className="nse-foot-txt">&nbsp;,&nbsp;</span>
                        <Link to="/content/TermsConditions" >
                            <span className="nse-foot-txt">{msg.txTermsConditions}</span>
                        </Link>
                    </div>
                </div>
            </footer>
        )
    }

}

export default Footer;